export const RegisterScreenActionTypes = {
    SET_LICENSE_AGREEMENT:'SET_LICENSE_AGREEMENT',
    SET_COUNTRIES:'SET_COUNTRIES',
    SET_EMAIL_VERIFY_STATUS:'SET_EMAIL_VERIFY_STATUS',
    SET_REGISTERED_USER:'SET_REGISTERED_USER',
    SET_RESET_PASSWORD_STATUS:'SET_RESET_PASSWORD_STATUS',
    SET_DELETE_ACCOUNT_STATUS:'SET_DELETE_ACCOUNT_STATUS',
    SET_DELETE_ACCOUNT_LINK_STATUS:'SET_DELETE_ACCOUNT_LINK_STATUS',
}